import { action, observable, computed } from 'mobx'

export class TaxRegistrationStore {
  @observable currentTaxRegistration = null
  @observable currentTableIndex = -1
  @observable taxRegistrationList = null
  @observable submissionGateWay = null

  @action setCurrentTaxRegistration = (currentTaxRegistration) => {
    this.currentTaxRegistration = currentTaxRegistration
  }

  @action setTaxRegistrationList = (taxRegistrationList) => {
    this.taxRegistrationList = taxRegistrationList
  }

  @computed get hasOnlineSubmissionGateway () {
    let hasOnlineSubmissionGateway = false
    if (this.taxRegistrationList) {
      hasOnlineSubmissionGateway = this.taxRegistrationList.filter((taxRegistration) => taxRegistration.SubissionGatewayOnline === true).length > 0
    }
    return hasOnlineSubmissionGateway
  }
}
